export default "https://cdn-static.gokick.com/assets/34e3985c60c1a4021cd40bb2eb2cab3e4962f61f/images/diastolic-smaller.c0fadbcdc01bd506880e051915c30039.svg";